import { NameIdTuple, TreeNodeExtenededResponseMessageDTO } from 'business/models/Models';
import React from 'react';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import { DELETE_CONFIRMATION_MESSAGES } from '../constants';

const messageFormatForScreen =
  ' is referenced by one or more experiments outside the scope of deletion and cannot be deleted.\n\n';
const messageFormatForExperiment =
  ' contains one or more seeds which are outside the scope of deletion and cannot be deleted.\n\n';
const messageFormatForFragment =
  ' is used by active experiments, please unlink this fragment from Experiment to delete';

const getErrorMessage = (errorMessage: string, nodeType: ETreeNodeTypes) => {
  if (errorMessage) {
    return errorMessage;
  } else {
    if (nodeType === ETreeNodeTypes.Experiment) {
      return messageFormatForExperiment;
    } else if (nodeType === ETreeNodeTypes.FragmentScreen) {
      return messageFormatForFragment;
    }
    return messageFormatForScreen;
  }
};

interface DeleteConfirmationModalProps {
  deletedNodes: NameIdTuple[];
  undeletedNodes: TreeNodeExtenededResponseMessageDTO[];
}

const DeleteConfirmationModal = (props: DeleteConfirmationModalProps) => {
  const { deletedNodes, undeletedNodes } = props;

  return (
    <>
      {deletedNodes.length > 0 && (
        <div id="explorer-deleteresponsemodalbody-content" className="text-gray-700">
          {DELETE_CONFIRMATION_MESSAGES.DELETE_ITEMS}
          {deletedNodes.map((node: NameIdTuple, index) => (
            <div
              id={`explorer-deleteresponsemodalbody-deleted-item-${node.name}`}
              className="ml-4 py-1"
              key={'deletedNode_' + index}
            >
              {`${index + 1}. ${node.name} ${
                node.imageCount !== 0 ? ` - ${node.imageCount} images` : ''
              }`}
            </div>
          ))}
        </div>
      )}
      {undeletedNodes.length > 0 && (
        <div id="explorer-deleteresponsemodalbody-notdeleted-title">
          {DELETE_CONFIRMATION_MESSAGES.UNABLE_TO_DELETE_ITEMS}
          {undeletedNodes.map((node, index) => (
            <div
              id={`explorer-deleteresponsemodalbody-notdeleted-item-${index}`}
              className="text-red-800 ml-4"
              key={index}
              title={getErrorMessage(node.responseMessage, node.type as ETreeNodeTypes)}
            >
              {`${index + 1}) ${node.name}`}
            </div>
          ))}
        </div>
      )}
    </>
  );
};
export default DeleteConfirmationModal;
